import ResourceManager, { ResourceType } from "../../components/ResourceManager/ResourceManager"
import { TodoViewModel } from "../api/todo"
import { useTodoMutations } from "../hooks/use-todo-mutations"
import { useI18n } from "../../hooks/use-i18n"
import { StringMap } from "../../types/common"
import { TodoProjectResponse } from "../api/todo-response"

const TodoProjectWidget = ({ todo, projectOptions }: Props) => {
  const { updateProject } = useTodoMutations()
  const translations = useTranslations(defaultTranslations)

  const projectResource: ResourceType[] = todo.project ? [{ id: todo.project.id, name: todo.project.title }] : []

  const onAddProject = (projectId: string) => {
    const project = projectOptions.find((p) => p.id === projectId)
    if (!project) return
    updateProject(todo.id, {
      project: { id: project.id, title: project.name } as TodoProjectResponse,
    })
  }

  const onRemoveProject = () => {
    updateProject(todo.id, { project: null })
  }

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={projectOptions}
      resources={projectResource}
      canAddResource={todo.canUpdate}
      canRemoveResource={todo.canUpdate}
      onAddResource={onAddProject}
      onRemoveResource={onRemoveProject}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection={false}
    />
  )
}

const useTranslations = (defaults = defaultTranslations) => {
  const { translations: t } = useI18n("todo")
  const translations = (t?.projectWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Project",
  emptyOptionsMessage: "No projects to connect this todo",
  emptyResourcesMessage: "This todo is not connected to any project",
  updateErrorMessage: "Failed to update project",
}

type Props = {
  todo: TodoViewModel
  projectOptions: ResourceType[]
}
export default TodoProjectWidget
